var _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBsScanDuration(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.3689 19.5712L10.0564 30.2197L10.2046 30.3373L24.9404 14.2895H18.1004L24.3417 4.29297H12.5667L8.86719 19.4613L13.3689 19.5712Z",
    fill: "#F99F0C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0798 19.4736L9.76731 30.122L9.91549 30.2397L24.6514 14.1919H17.8114L24.0526 4.19531H12.2777L8.57812 19.3636L13.0798 19.4736Z",
    fill: "#F99F0C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7907 19.3759L9.47824 30.0244L9.62643 30.142L24.3623 14.0942H17.5223L23.7636 4.09766H11.9886L8.28906 19.266L12.7907 19.3759Z",
    fill: "#F99F0C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5017 19.2783L9.18918 29.9267L9.33736 30.0444L24.0732 13.9966H17.2332L23.4745 4H11.6995L8 19.1683L12.5017 19.2783Z",
    fill: "#F99F0C"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3689 19.5712L10.0564 30.2197L10.2046 30.3373L24.9404 14.2895H18.1004L24.3417 4.29297H12.5667L8.86719 19.4613L13.3689 19.5712Z",
    fill: "url(#paint0_linear_13878_12495)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_13878_12495",
    x1: 16.9038,
    y1: 4.29297,
    x2: 16.9038,
    y2: 30.3373,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEC10E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDA50F"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBsScanDuration);
export default __webpack_public_path__ + "static/media/bs_scan_duration.2d466a5f4a1b6b25cd486bc95a1530b6.svg";
export { ForwardRef as ReactComponent };